"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autorun = exports.getAutoObservable = exports.runReaction = exports.createObservable = void 0;
const reactiveState_constants_1 = require("./reactiveState.constants");
const reactiveState_utils_1 = require("./reactiveState.utils");
const context = {
    disposes: null,
    effect: null,
    withValue: false,
};
let reactions = null;
const effects = new WeakMap();
const notify = (property, effect, disposes) => {
    let callbacks = effects.get(property);
    if (!callbacks) {
        callbacks = new Set();
        effects.set(property, callbacks);
    }
    callbacks.add(effect);
    disposes.add(() => callbacks.delete(effect));
};
const wrapObject = (object) => Object.entries(object).reduce((acc, [key, value]) => (0, reactiveState_utils_1.setProperty)(acc, key, (0, reactiveState_utils_1.isObject)(value) ? (0, exports.createObservable)(value) : value), {});
const createObservable = (object) => {
    return new Proxy(wrapObject(object), {
        get: (target, prop) => {
            let property = target[prop];
            const { disposes, effect, withValue } = context;
            if (effect && !property) {
                (0, reactiveState_utils_1.setProperty)(target, prop);
                property = target[prop];
            }
            if (effect && Object.prototype.hasOwnProperty.call(target, prop)) {
                notify(property, effect, disposes);
            }
            return withValue ? property : property === null || property === void 0 ? void 0 : property[reactiveState_constants_1.VALUE];
        },
        set: (target, prop, nextValue) => {
            let property = target[prop];
            if (!property) {
                (0, reactiveState_utils_1.setProperty)(target, prop);
                property = target[prop];
            }
            const value = typeof nextValue === 'function' ? nextValue(property[reactiveState_constants_1.VALUE]) : nextValue;
            if (property[reactiveState_constants_1.VALUE] === value) {
                return true;
            }
            const result = Reflect.set(target, prop, { [reactiveState_constants_1.VALUE]: (0, reactiveState_utils_1.isObject)(value) ? (0, exports.createObservable)(value) : value });
            const callbacks = [...(effects.get(property) || [])];
            callbacks.forEach(callback => (reactions ? reactions.add(callback) : callback()));
            return result;
        },
    });
};
exports.createObservable = createObservable;
const runReaction = (callback) => {
    if (reactions) {
        callback();
        return;
    }
    reactions = new Set();
    callback();
    const currentReactions = [...reactions];
    reactions = null;
    currentReactions.forEach(reaction => reaction());
};
exports.runReaction = runReaction;
const getAutoObservable = (observable, effect) => {
    const disposes = new Set();
    const proxies = new WeakMap();
    let observe = false;
    const dispose = () => {
        disposes.forEach(item => item());
        disposes.clear();
    };
    const createProxy = (object) => new Proxy(object, {
        get: (target, prop) => {
            if (!observe) {
                return target[prop];
            }
            context.effect = effect;
            context.disposes = disposes;
            context.withValue = true;
            const property = target[prop];
            let proxy;
            const value = property[reactiveState_constants_1.VALUE];
            if ((0, reactiveState_utils_1.isObject)(value)) {
                proxy = proxies.get(property);
                if (!proxy) {
                    proxy = createProxy(value);
                    proxies.set(property, proxy);
                }
            }
            context.effect = null;
            context.disposes = null;
            context.withValue = false;
            return proxy || value;
        },
    });
    const subscribe = () => {
        dispose();
        observe = true;
    };
    const unsubscribe = () => {
        observe = false;
    };
    return { dispose, observable: createProxy(observable), subscribe, unsubscribe };
};
exports.getAutoObservable = getAutoObservable;
const autorun = (callback) => {
    const disposes = new Set();
    const dispose = () => {
        disposes.forEach(item => item());
        disposes.clear();
    };
    const run = () => {
        dispose();
        context.effect = run;
        context.disposes = disposes;
        callback();
        context.effect = null;
        context.disposes = null;
    };
    run();
    return dispose;
};
exports.autorun = autorun;
//# sourceMappingURL=reactiveState.js.map